Promise.all([
  import(/* webpackMode: "eager" */ './promo-box.scss'),
  import('../../plugins/magnific-popup/magnific-popup.css'),
  import('../../plugins/magnific-popup/jquery.magnific-popup.js'),
]).then(() => {
  $('.widget.promo-box').each(function (i, el) {
    $(el).data('widget', new PromoBox(el))
    $(el).data('widget').init()
  })
})

function PromoBox(el) {
  const self = this
  self.el = $(el)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('PromoBox init', self)
    }
    self.el.css('opacity', 1)

    self.el.find('.video-trigger').each(function (i, el) {
      $(el).magnificPopup({
        type: 'inline',
        items: {
          src: $(el).parents('.promo').find('.promo-box-video-popup'),
        },
        callbacks: {
          open: function () {
            $('html').css('margin-right', 0)
            $(this.content).find('video')[0].play()
          },
          close: function () {
            $(this.content).find('video')[0].load()
          },
        },
      })
    })
  }
}
